import formatTimestamp from "@/utils/formatTimestamp";
import { useEffect, useRef, useState } from "react";
import ChatInput from "./ChatInput";
import replyIcon from "@img/reply.svg";
import fileIcon from "@img/file.svg";

const ChatBody = ({
  chatBodyRef,
  user,
  messages,
  adminId,
  theme,
  loading,
  selectedUser,
  replyTo,
  setReplyTo,
}) => {
  const [message, setMessage] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const messagesContainerRef = useRef(null);

  const handleImageClick = (url) => {
    setSelectedImage(url);
  };

  const closeImageModal = () => {
    setSelectedImage(null);
  };

  useEffect(() => {
    if (messagesContainerRef.current) {
      messagesContainerRef.current.scrollTop =
        messagesContainerRef.current.scrollHeight;
    }
  }, [messages]);

  const renderFile = (fileUrl) => {
    const decodedUrl = decodeURIComponent(fileUrl);
    const fileNameWithParams = decodedUrl.split("/").pop();

    const fileName = fileNameWithParams.split("?")[0];
    const fileExtension = fileName.split(".").pop().toLowerCase();

    if (["jpg", "jpeg", "png", "gif", "svg"].includes(fileExtension)) {
      return (
        <div
          key={fileUrl}
          className="chat-message__file"
          onClick={() => handleImageClick(fileUrl)}
        >
          <img
            loading="lazy"
            width={100}
            src={fileUrl}
            alt="Отправленный файл"
          />
        </div>
      );
    } else {
      return (
        <div key={fileUrl}>
          <a
            href={fileUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="chat-body__file"
            style={{ color: "black" }}
          >
            <img src={fileIcon} width={15} alt="file-icon" />
            {`${fileName.slice(0, 20)}...`}
          </a>
        </div>
      );
    }
  };

  return (
    <div
      id="chat-body"
      ref={chatBodyRef}
      className={`chat-body chat-body--${theme}`}
    >
      <div className="chat-messages" ref={messagesContainerRef}>
        {loading && (
          <div className="loader-overlay">
            <span className="loader"></span>
          </div>
        )}
        {messages.map((msg, index) => (
          <div
            key={index}
            className={`chat-message-box ${
              msg.senderId === user.uid
                ? "chat-message-box--right"
                : "chat-message-box--left"
            }`}
          >
            {msg.senderId !== user.uid && (
              <p className="chat-message__timestamp">
                {formatTimestamp(msg.timestamp)}
              </p>
            )}

            <div
              key={msg.id}
              onDoubleClick={() => setReplyTo(msg)}
              className={`chat-message ${
                msg.senderId === user.uid
                  ? "chat-message--right"
                  : "chat-message--left"
              }`}
            >
              <div className="chat-message-inner">
                {msg.replyTo && (
                  <div className="chat-message--reply">
                    {msg.replyTo.fileUrl && renderFile(msg.replyTo.fileUrl)}
                    {msg.replyTo.message && msg.replyTo.message.length > 100
                      ? `${msg.replyTo.message.substring(0, 100)}...`
                      : msg.replyTo.message}
                  </div>
                )}
                {msg.message && <p>{msg.message}</p>}
                {msg.fileUrl && renderFile(msg.fileUrl)}
              </div>

              <button
                onClick={() => setReplyTo(msg)}
                className="chat-message__replyBtn"
              >
                <img loading="lazy" src={replyIcon} alt="reply-icon" />
              </button>
            </div>
            {msg.senderId === user.uid && (
              <p className="chat-message__timestamp">
                {formatTimestamp(msg.timestamp)}
              </p>
            )}
          </div>
        ))}
      </div>

      {user.uid === adminId && !selectedUser ? null : (
        <ChatInput
          id={user.uid}
          theme={theme}
          message={message}
          selectedUser={selectedUser}
          adminId={adminId}
          setMessage={setMessage}
          selectedImage={selectedImage}
          closeImageModal={closeImageModal}
          replyTo={replyTo}
          setReplyTo={setReplyTo}
        ></ChatInput>
      )}
    </div>
  );
};

export default ChatBody;
